export function formatDate(string, format = null) {
  let options = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    timeZone: 'UTC',
  }

  if (format === 'M/D') {
    options = {
      month: 'numeric',
      day: 'numeric',
      timeZone: 'UTC',
    }
  }

  if (format === 'MMM D') {
    options = {
      month: 'short',
      day: 'numeric',
      timeZone: 'UTC',
    }
  }

  if (format === 'MMM D, YYYY') {
    options = {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      timeZone: 'UTC',
    }
  }

  return new Date(string).toLocaleString('en-US', options)
}

export function formatDateSlash(string) {
  let options = {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    timeZone: 'UTC',
  }

  return new Date(string).toLocaleString('en-US', options)
}

export function formatDateTime(string) {
  let options = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }

  return new Date(string).toLocaleString('en-US', options)
}

export function formatTime(string, timeZone = 'UTC') {
  let options = {
    hour: 'numeric',
    minute: '2-digit',
    timeZone,
  }

  return new Date(string).toLocaleString('en-US', options)
}

export function formatDateDayOfWeek(string) {
  const date = new Date(string)
  return date.toLocaleDateString('en-US', { weekday: 'short', timeZone: 'UTC' })
}

export function formatDateLongMonth(month) {
  return new Date(0, month - 1).toLocaleString('default', {
    month: 'long',
  })
}

export function dateRemoveTimezoneOffset(date) {
  date.setMinutes(date.getMinutes() - date.getTimezoneOffset())

  return date
}

export function getDateTimeISOStringNextDay9AM() {
  let date = new Date()

  date.setHours(9)
  date.setMinutes(0)
  date.setDate(date.getDate() + 1)

  return dateRemoveTimezoneOffset(date).toISOString()
}

export function getDateISOString(dateOrString) {
  let date =
    typeof dateOrString === 'string' ? new Date(dateOrString) : dateOrString

  return dateRemoveTimezoneOffset(date).toISOString().substring(0, 10)
}

export function getDateISOStringNextYear() {
  let date = new Date()

  date.setFullYear(date.getFullYear() + 1)

  return getDateISOString(date)
}

export function getDateISOStringToday() {
  return getDateISOString(new Date())
}

export function groupObjectsByWeekUTC(objects) {
  const weeks = []

  // Helper function to get the Sunday of the week for a given UTC date
  const getSundayUTC = (date) => {
    const day = date.getUTCDay() // Get current day number in UTC
    const diff = date.getUTCDate() - day // Adjust to previous Sunday in UTC
    return new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), diff))
  }

  // Helper function to format date to YYYY-MM-DD in UTC
  const formatDateUTC = (date) => {
    return new Date(date).toISOString().split('T')[0]
  }

  objects.forEach((object) => {
    const dateString = object.date
    const date = new Date(dateString)
    const sunday = getSundayUTC(new Date(date))
    const saturday = new Date(
      Date.UTC(
        sunday.getUTCFullYear(),
        sunday.getUTCMonth(),
        sunday.getUTCDate() + 6
      )
    ) // Get the Saturday of the week in UTC

    // Find if there's already a week object for this week
    const weekIndex = weeks.findIndex(
      (week) =>
        formatDateUTC(week.startDate) === formatDateUTC(sunday) &&
        formatDateUTC(week.endDate) === formatDateUTC(saturday)
    )

    // If the week exists, add the date to it, otherwise create a new week object
    if (weekIndex > -1) {
      weeks[weekIndex].objects.push(object)
    } else {
      weeks.push({
        startDate: formatDateUTC(sunday),
        endDate: formatDateUTC(saturday),
        objects: [object],
        toString: function () {
          return (
            formatDateSlash(this.startDate) +
            ' - ' +
            formatDateSlash(this.endDate)
          )
        },
      })
    }
  })

  return weeks.sort((a, b) => {
    return new Date(a.startDate) - new Date(b.startDate)
  })
}

export function groupObjectsByMonthUTC(objects) {
  const months = {}

  // Helper function to get the first day of the month for a given UTC date
  const getFirstDayOfMonthUTC = (date) => {
    return new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), 1))
  }

  // Helper function to format date to YYYY-MM in UTC
  const formatMonthUTC = (date) => {
    return date.toISOString().substring(0, 7)
  }

  objects.forEach((object) => {
    const dateString = object.date
    const date = new Date(dateString)
    const firstDayOfMonth = getFirstDayOfMonthUTC(date)
    const monthKey = formatMonthUTC(firstDayOfMonth)

    // If the month exists, add the date to it, otherwise create a new month array
    if (!months[monthKey]) {
      months[monthKey] = {
        key: monthKey,
        startDate: formatMonthUTC(firstDayOfMonth) + '-01',
        endDate:
          formatMonthUTC(
            new Date(
              Date.UTC(
                firstDayOfMonth.getUTCFullYear(),
                firstDayOfMonth.getUTCMonth() + 1,
                0
              )
            )
          ) +
          '-' +
          new Date(
            Date.UTC(
              firstDayOfMonth.getUTCFullYear(),
              firstDayOfMonth.getUTCMonth() + 1,
              0
            )
          ).getUTCDate(),
        objects: [],
        toString: function () {
          return new Date(this.startDate).toLocaleString('en-US', {
            year: 'numeric',
            month: 'long',
            timeZone: 'UTC',
          })
        },
      }
    }
    months[monthKey].objects.push(object)
  })

  // Convert the months object to an array of month objects and sort by month
  return Object.values(months).sort((a, b) => {
    return new Date(a.startDate) - new Date(b.startDate)
  })
}
